module.exports = __webpack_public_path__ + "media/images/down-699f4dd8e2a54c7d18b22940a776e50d.svg";